var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "live-country" }, [
    _c("div", { staticClass: "region-selector-content w-100" }, [
      _c("div", { staticClass: "form-group m-0" }, [
        _vm.regions
          ? _c(
              "span",
              {
                staticClass:
                  "error-input-container dropdown-with-info-container"
              },
              [
                _vm.selectedRegion
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "dropdown-with-info-container--toggle whitespace-nowrap"
                      },
                      [
                        _c("span", { staticClass: "color-back" }, [
                          _vm._v(_vm._s(_vm.selectedRegion.name))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedRegionIso,
                        expression: "selectedRegionIso"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedRegionIso = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeRegion
                      ]
                    }
                  },
                  _vm._l(_vm.regions, function(region) {
                    return _c("option", { domProps: { value: region.iso } }, [
                      _vm._v(_vm._s(region.name))
                    ])
                  }),
                  0
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f3363d5", { render: render, staticRenderFns: staticRenderFns })
  }
}